
export default function WhatWeDoSection() {
  const services = [
    {
      icon: 'ri-user-add-line',
      title: 'Lead Generation A.I.',
      description: 'Re-engages old leads and books new ones 24/7 with intelligent conversation flows and automated follow-up sequences.',
      image: 'https://public.readdy.ai/ai/img_res/a58cf57434d1f752cc453e7e65a18977.jpg'
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Process Automation A.I.',
      description: 'Simplifies admin, billing, and operations instantly by automating repetitive tasks and streamlining workflows.',
      image: 'https://readdy.ai/api/search-image?query=Automated%20business%20process%20workflow%20visualization%2C%20modern%20office%20environment%20with%20digital%20automation%20tools%2C%20clean%20interface%20showing%20task%20management%20and%20billing%20systems%2C%20professional%20workspace%20with%20multiple%20monitors%2C%20streamlined%20operations%20dashboard&width=400&height=300&seq=automation&orientation=landscape'
    },
    {
      icon: 'ri-heart-line',
      title: 'Client Experience A.I.',
      description: 'Turns one-time buyers into recurring revenue through personalized engagement and intelligent customer journey optimization.',
      image: 'https://readdy.ai/api/search-image?query=Customer%20experience%20dashboard%20showing%20client%20satisfaction%20metrics%2C%20modern%20CRM%20interface%20with%20personalization%20features%2C%20professional%20service%20environment%2C%20client%20relationship%20management%20tools%2C%20recurring%20revenue%20analytics%2C%20clean%20business%20design&width=400&height=300&seq=client-exp&orientation=landscape'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            What We Do
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our A.I. agents work around the clock to grow your business through intelligent automation and personalized customer experiences.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="group bg-gray-50 rounded-2xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className="mb-6">
                <img 
                  src={service.image}
                  alt={service.title}
                  className="w-full h-48 object-cover rounded-xl"
                />
              </div>
              
              <div className="w-12 h-12 bg-gradient-to-r from-blue-600 to-purple-600 rounded-xl flex items-center justify-center mb-6">
                <i className={`${service.icon} text-white text-xl`}></i>
              </div>
              
              <h3 className="text-xl font-semibold text-gray-900 mb-4">
                {service.title}
              </h3>
              
              <p className="text-gray-600 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
